import { Gateway } from '../../../../shared/api/gateway/Gateway';
import { DeleteVehicleRequest } from '../../../../shared/api/gateway/types/vehicle';

export type ILoaderDeleteVehicle = (
	data: DeleteVehicleRequest,
) => Promise<void>;

export function deleteVehicleLoader(api: Gateway): ILoaderDeleteVehicle {
	return async (data) => {
		await api.vehicle().deleteVehicle(data);
	};
}
